export default __webpack_public_path__ + "static/media/Parent_Illustrations-08.0e545340.svg";